<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "./info.vue";
import Check from "./check.vue";
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    info: Info,
    // Repair,
    // Track,
    Check,
  },
  data() {
    return {
      table: {
        mname: "patrol",
        key: "id",
        url: {
          list: "/admin/system/patrol/list?onlySceneState=1",
          del: "/admin/system/patrol",
        },
        output: false,
        order: "createTime",
      },
      query: {
        onlySceneState: 1,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/inspection/add",
        },
      ],
      menus: [
        {
          label: "盘点纪录",
          name: "inventory_record_list",
          auth: "system/inventoryRecordList/index",
        },
        {
          label: "主动巡检",
          name: "active_inspection_list",
          auth: "system/activeInspectionList/index",
        },
        {
          label: "定时巡检",
          name: "inspection_list",
          auth: "system/inspection/index",
        },
        // {
        //   label: "模板管理",
        //   name: "templateManagement_list",
        //   auth: "system/templateManagement/index",
        // },
        // { label: "场景管理", name: "scene_list", auth: "system/scene/index" },
      ],
      filters: [
        {
          label: "负责人",
          KeyEnter: this.search,
          name: "maintainerId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "巡检时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "巡检类别",
          KeyEnter: this.search,
          name: "patrolDimension",
          value: "",
          type: "select",
          dropList: [
            { value: 1, name: "设备" },
            { value: 2, name: "巡检类别" },
          ],
        },
        {
          label: "巡检项",
          KeyEnter: this.search,
          name: "patrolContent",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        // {
        //   title: "巡检名称",
        //   key: "patrolName",
        //   minWidth: 120,
        //   align: "left",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.patrolName;
        //     return (
        //       <span
        //         style={{
        //           color: row.state == 1 ? "red" : "",
        //         }}
        //       >
        //         {text}
        //       </span>
        //     );
        //   },
        // },

        // {
        //   title: "巡检维度",
        //   key: "patrolDimension",
        //   minWidth: 120,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text =
        //       row.patrolDimension == 1
        //         ? "资产"
        //         : row.patrolDimension == 2
        //           ? "场景"
        //           : "";
        //     return (
        //       <span
        //         style={{
        //           color: row.state == 1 ? "red" : "",
        //         }}
        //       >
        //         {text}
        //       </span>
        //     );
        //   },
        // },
        {
          title: "二维码",
          width: 80,
          align: "center",
          key: "qrCode",
          viewimage: true,
        },
        {
          title: "巡检单号",
          width: 100,
          align: "center",
          key: "id",
        },
        {
          title: "巡检类别",
          key: "patrolDimension",
          width: 200,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolScene ? row.patrolScene : "设备";
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检项",
          key: "patrolContent",
          minWidth: 150,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolContent;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: '场景',
        //   key: 'patrolScene',
        //   minWidth: 120,
        //   align: 'left',
        // },
        // {
        //   title: "场景地址",
        //   key: "sceneSite",
        //   minWidth: 120,
        //   align: "left",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.sceneSite;
        //     return (
        //       <span
        //         style={{
        //           color: row.state == 1 ? "red" : "",
        //         }}
        //       >
        //         {text}
        //       </span>
        //     );
        //   },
        // },
        {
          title: "定时周期",
          key: "patrolInterval",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.timeUnit == 1
                ? row.patrolInterval + "分钟"
                : row.timeUnit == 2
                ? row.patrolInterval + "小时"
                : row.timeUnit == 3
                ? row.patrolInterval + "天"
                : row.timeUnit == 4
                ? row.patrolInterval + "周"
                : row.timeUnit == 5
                ? row.patrolInterval + "月"
                : row.timeUnit == 6
                ? row.patrolInterval + "季度"
                : row.timeUnit == 7
                ? row.patrolInterval + "年"
                : "";
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: '巡检开始时间',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'patrolBeginTime',
        // },
        {
          title: "开始时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "负责人",
          key: "name",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.name;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "操作",
          align: "center",
          width: 210,
          key: "handle",
          fixed: "right",
          handle: [
            // (vm, h, currentRow, param) => {
            //   let directives = [{ name: 'auth', value: '/admin/inspection/edit' }]
            //   return (
            //     <Button {...{ directives }} size="small" onClick={() => this.toAdd(currentRow)} type="text" style={{ margin: '0', color: '#66A2FF' }}>
            //       编辑
            //     </Button>
            //   )
            // },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "system/inspection/check" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toCheck(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  巡检记录
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "system/inspection/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toinfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    margin: "0",
                  }}
                >
                  详情
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            // edit: "system/knowledgeBaseTag/edit",
            del: "system/inspection/delete",
          },
        },
      ],
    };
  },
  created() {
    this.loaduserData();
  },
  methods: {
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toCheck(row) {
      this.$Modal.success({
        closable: true,
        title: "巡检记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Check
              style={{ margin: "0", color: "#19be6b" }}
              planId={row.id}
            ></Check>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({ name: "inspection_add", query: { action: "add" } });
    },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "inspection_edit", query: {action: "edit", kv: currentRow.id } });
    // },
    //详情
    toinfo(row) {
      $utils.url.push({
        name: "inspection_info",
        query: { action: "edit", kv: row.id, planId: row.id },
      });
    },
    // //导出
    // toImport() {},
    // //下载模板
    // toDownload() {},
  },
};
</script>
<style scoped></style>
